import { render, staticRenderFns } from "./courseRecordOverview.vue?vue&type=template&id=5c9a7414"
import script from "./courseRecordOverview.vue?vue&type=script&lang=js"
export * from "./courseRecordOverview.vue?vue&type=script&lang=js"
import style0 from "./courseRecordOverview.vue?vue&type=style&index=0&id=5c9a7414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports